import React from 'react';
import PropTypes from 'prop-types';
import style from './index.css';
import ColumnIntro from '../../../components/columnIntro';
import { NewsStream } from '@ifeng-fe/news-stream';
import '@ifeng-fe/news-stream/lib/NewsStream/style/news-stream-global.css';

class Content extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    loadmore = async () => {
        return {
            data: {
                newsstream: [],
                isEnd: true,
            },
        };
    };

    render() {
        const { content } = this.props;
        const { columnIntroData, newsstream, columnId } = content;

        /**
         * 组件分发数据
         */
        return (
            <div className={style.wrap_1000w}>
                <div className={style.left_640w}>
                    <NewsStream isPic={true} content={newsstream} columnId={columnId} isDisplayLoadingMore />
                </div>
                <div className={style.right_300w}>
                    <ColumnIntro content={columnIntroData} />
                </div>
            </div>
        );
    }
}

export default Content;
